import React, { Component } from 'react';
import ReactDOM from "react-dom";
import Loader from "./Loader";
import { ToastContainer, toast } from 'react-toastify';
import Axios from "axios";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import EnderecoEnprendimentoPartialForm from "./TicketsSupport/EnderecoEnprendimentoPartialForm";
import cep from "cep-promise";
import IntlCurrencyInput from "react-intl-currency-input";
import EstoqueValoresForm from "./TicketsSupport/EstoqueValoresForm";
import EstoqueValoresTable from "./TicketsSupport/EstoqueValoresTable";

const ASSUNTO_ORDEM_FIXA = ['Erro no sistema', 'Outros'];

const sortAssuntoOutrosLast = (a, b) => {
    const posA = ASSUNTO_ORDEM_FIXA.indexOf(a);
    const posB = ASSUNTO_ORDEM_FIXA.indexOf(b);
    if (posA !== -1 && posB !== -1) return posA - posB;
    if (posA !== -1) return 1;
    if (posB !== -1) return -1;
    return a.localeCompare(b, 'pt-BR');
};

const FIELD_PLACEHOLDER_FONT = {
    fontFamily: "'Archivo', sans-serif",
    fontStyle: 'italic',
    fontWeight: 400,
    fontSize: '20px',
    color: '#B3B3B3',
};

const FIELD_VALUE_FONT = {
    fontFamily: "'Archivo Expanded', sans-serif",
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '19px',
    color: '#5B595B',
};

const BTN_CHAMADO = {
    fontFamily: "'Archivo Expanded', sans-serif",
    fontWeight: 600,
    fontSize: '25px',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    padding: '8px 12px',
    borderRadius: 0,
    border: 'none',
    cursor: 'pointer',
};

const selectStyles = {
    control: (base, { isDisabled }) => ({ ...base, borderRadius: 0, border: '4px solid #F2F2F2', backgroundColor: isDisabled ? 'rgba(178, 178, 178, 0.13)' : base.backgroundColor }),
    menu:     (base) => ({ ...base, borderRadius: 0 }),
    menuList: (base) => ({ ...base, borderRadius: 0 }),
    dropdownIndicator: (base, { isDisabled }) => ({ ...base, display: isDisabled ? 'none' : 'flex' }),
    indicatorSeparator: () => ({ display: 'none' }),
    option: (base, { data, options, isSelected, isFocused }) => ({
        ...base,
        backgroundColor: isSelected
            ? '#BCBEC0'
            : isFocused
                ? '#D5D6D8'
                : options.indexOf(data) % 2 === 0 ? '#EEEFF0' : '#FFFFFF',
        color: '#5B595B',
    }),
    placeholder: (base) => ({ ...base, ...FIELD_PLACEHOLDER_FONT }),
    singleValue: (base) => ({ ...base, ...FIELD_VALUE_FONT }),
    input:       (base) => ({ ...base, ...FIELD_VALUE_FONT }),
};

export default class FormChamado extends Component {

    constructor(props) {
        super();

        this.state = {
            nome: '',
            building_id: '',
            assunto: '',
            cidade: '',
            mensagem: '',
            anexos: [],
            errors: [],
            loading: false,
            assuntos: ['Inclusão de empreendimento', 'Informações faltantes ou incorretas', 'Erro no sistema', 'Outros'],
            observacoes: {
                "Informações faltantes ou incorretas": ['Localização Incorreta', 'Estoque incorreto', 'Valor incorreto', 'Tipologia', 'Ficha técnica', 'Informações Gerais Incorretas'],
                "Outros": ['Envio de Material', 'Dúvida']
            },
            observacao: '',
            bairro: '',
            cep: '',
            endereco: '',
            numero: '',
            complemento: '',
            longitude: '',
            latitude: '',
            cidade_empreendimento: '',
            estado_empreendimento: '',
            tipologias: [],
        }
    }

    searchEmpreendimentos = async (inputQuery) => {
        if (inputQuery.length > 1) {
            try {

                let params = {
                    term: inputQuery
                };

                if (this.state.cidade !== '') {

                    let parts = this.state.cidade.value.split('-');

                    params.cidade = parts[0];
                    params.estado = parts[1];
                }

                let endpoint = route('search-buildings', params);

                let empreendimentos = await axios.get(endpoint);

                return empreendimentos.data;
            } catch (error) {
                console.log(error);
            }
        }
    }

    searchCidade = async (inputQuery) => {
        if (inputQuery.length >= 2) {
            const response = await Axios.get('/cidades/json-options-with-state-on-values/' + inputQuery);
            return response.data;

        }
    }

    updateTipologias = async (tipologias) => {
        await this.setState({
            ...this.state,
            tipologias: tipologias
        }
        );
    }

    submitForm = async (e) => {
        e.preventDefault();

        try {
            await this.setLoading(true);
            await this.setState({
                ...this.state, errors: [],
            });

            if (this.state.observacao === 'Localização Incorreta' && (this.state.latitude === '' || this.state.longitude === '')) {
                await this.getCoordinatesFromAddress();
            }

            const data = new FormData();

            Object.keys(this.state).forEach(key => {
                if (key !== 'errors' && key !== 'loading' && key !== 'assuntos' && key !== 'anexos') {
                    if (this.state[key] !== null && this.state[key] !== undefined && this.state[key] !== '') {
                        let value = this.state[key];

                        if (key === 'tipologias') {
                            value = JSON.stringify(this.state[key]);
                        }

                        data.append(key, value);

                    }
                }
            });

            for (const key in Object.keys(this.state.anexos)) {
                data.append('anexos[]', this.state.anexos[key]);
            }

            if (this.state.cidade !== '') {
                let parts = this.state.cidade.value.split('-');
                data.append('cidade', parts[0].trim());
                data.append('estado', parts[1].trim());
            }

            if (this.state.building_id !== '') {
                data.delete('nome');
                data.append('empreendimento', this.state.building_id);
            }

            this.setState({ loading: true });

            let response = await axios.post(route('chamado.store'), data);

            if (response.status === 201) {

                toast.success(`Chamado ${response.data.id} Criado com sucesso!`);


                setTimeout(() => {
                    window.location.href = route('chamados.index');
                }, 2000);
            }

        } catch (e) {

            if (e.response && e.response.status === 422) {
                this.setState({ errors: e.response.data.errors });
            }

            console.log(e);
        } finally {
            this.setLoading(false);
        }


    }

    setLoading = async (loading) => {

        await this.setState({
            loading: loading
        });
    }


    componentDidMount = async () => {

        const urlParams = new URLSearchParams(window.location.search);

        if (urlParams.has('assunto') && urlParams.get('assunto') === 'sugerir_inclusao') {
            await this.setState({
                ...this.state,
                assunto: 'Inclusão de empreendimento'
            });
        }

        if (urlParams.has('empreendimento')) {
            try {
                await this.setLoading(true);

                let response = await axios.get(route('building.show', urlParams.get('empreendimento')));

                if (response.status === 200) {
                    const latitude = parseFloat(response.data.building.latitude);
                    const longitude = parseFloat(response.data.building.longitude);

                    await this.setState({
                        ...this.state,
                        nome: response.data.building.name,
                        building_id: response.data.building.id,
                        assunto: 'Informações faltantes ou incorretas',
                        cidade: {
                            label: response.data.building.city?.city + ' - ' + response.data.building.city?.state,
                            value: response.data.building.city?.city + '-' + response.data.building.city?.state
                        },
                        empreendimento: {
                            value: response.data.building.id,
                            label: response.data.building.name + ' - ' + response.data.building.city?.city + ' - ' + response.data.building.city?.state
                        },
                        bairro: response.data.building.neighborhood,
                        cep: response.data.building.zip_code,
                        endereco: response.data.building.address,
                        numero: response.data.building.number,
                        complemento: response.data.building.complement,
                        longitude: !isNaN(longitude) ? longitude : '',
                        latitude: !isNaN(latitude) ? latitude : '',
                        cidade_empreendimento: response.data.building.city?.city,
                        estado_empreendimento: response.data.building.city?.state,
                        tipologias: response.data.tipologias
                    });

                    if (isNaN(latitude) || isNaN(longitude)) {
                        await this.getCoordinatesFromAddress();
                    } else {
                        this.centerMap();
                    }
                }
            } catch (e) {
                console.log(e);
            } finally {
                await this.setLoading(false);
            }
        }
    }

    onChangefile = async (e) => {
        this.setState({
            ...this.state, anexos: e.target.files
        });
    }

    onChangeNome = async (e) => {
        this.setState({
            ...this.state, nome: e.target.value
        });
    }

    onChangeAssunto = (e) => {
        this.setState({
            ...this.state,
            assunto: e.target.value,
            observacao: ""
        });
    }

    onChangeObservacao = (e) => {
        this.setState({
            ...this.state, observacao: e.target.value
        });
    }

    onChangeCidade = (e) => {
        this.setState({
            ...this.state, cidade: e.target.value
        });
    }

    onChangeMensagem = (e) => {
        this.setState({
            ...this.state, mensagem: e.target.value
        });
    }

    onChangeLongitude = async (e) => {
        this.setState({
            ...this.state, longitude: e.target.value
        });

        this.centerMap();
    }

    onChangeLatitude = async (e) => {
        await this.setState({
            ...this.state, latitude: e.target.value
        });

        this.centerMap();
    }

    centerMap = () => {
        let location = {
            lat: parseFloat(this.state.latitude),
            lng: parseFloat(this.state.longitude)
        };

        window.googleMap.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.setCenter(location);

        window.googleMap.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.setZoom(18);

        window.googleMap.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.panTo(
            location
        );

    }

    onChangeEndereco = (e) => {
        this.setState({
            ...this.state, endereco: e.target.value
        });
    }

    onChangeBairro = (e) => {
        this.setState({
            ...this.state, bairro: e.target.value
        });
    }

    onChangeComplemento = (e) => {
        this.setState({
            ...this.state, complemento: e.target.value
        });
    }

    onChangeCep = async (e) => {

        let cepInput = e.target.value.replace(/\D/g, '');

        await this.setState({
            ...this.state, cep: cepInput
        });

        try {
            if (cepInput.length >= 8) {
                let cepResponse = await cep(cepInput);
                console.log(cepResponse);

                if (cepResponse) {
                    this.setState({
                        ...this.state,
                        endereco: cepResponse.street,
                        bairro: cepResponse.neighborhood,
                        cidade_empreendimento: cepResponse.city,
                        estado_empreendimento: cepResponse.state

                    });
                }
            }


        } catch (e) {
            console.log(e);
        }


    }

    waitForGeocoder = (resolve, attempts = 0) => {
        if (window.google && window.google.maps && window.google.maps.Geocoder) {
            resolve();
            return;
        }
        if (attempts > 40) {
            resolve();
            return;
        }
        setTimeout(() => this.waitForGeocoder(resolve, attempts + 1), 100);
    }

    loadGoogleMapsScript = () => {
        return new Promise((resolve) => {
            if (window.google && window.google.maps && window.google.maps.Geocoder) {
                resolve();
                return;
            }
            const existing = document.getElementById('form-chamado-gmaps-script');
            if (existing) {
                this.waitForGeocoder(resolve);
                return;
            }
            window._formChamadoInitMap = () => this.waitForGeocoder(resolve);
            const script = document.createElement('script');
            script.id = 'form-chamado-gmaps-script';
            script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyBu0-76sJL5A8Ss84aFm9PrpdoB2pktrgI&libraries=places&callback=_formChamadoInitMap`;
            script.async = true;
            document.head.appendChild(script);
        });
    }

    getCoordinatesFromAddress = async (e) => {
        await this.loadGoogleMapsScript();

        const address = [this.state.endereco, this.state.numero, this.state.bairro, this.state.cidade_empreendimento, this.state.estado_empreendimento, this.state.cep, 'Brasil']
            .filter(Boolean)
            .join(', ');

        const geocoder = new window.google.maps.Geocoder();

        try {
            const results = await new Promise((resolve, reject) => {
                geocoder.geocode({ address }, (results, status) => {
                    if (status === 'OK' && results[0]) {
                        resolve(results);
                    } else {
                        reject(status);
                    }
                });
            });

            const location = results[0].geometry.location;

            await this.setState({
                ...this.state,
                latitude: location.lat(),
                longitude: location.lng()
            });

            this.centerMap();
        } catch (e) {
            console.log(e);
            toast.error('Não foi possível encontrar a geolocalização para este endereço.');
        }
    }


    onChangeCidadeEmpreendimento = (e) => {
        this.setState({
            ...this.state, cidade_empreendimento: e.target.value
        });
    }

    onChangeEstadoEmpreendimento = (e) => {
        this.setState({
            ...this.state, estado_empreendimento: e.target.value
        });
    }

    onChangeNumero = (e) => {
        this.setState({
            ...this.state, numero: e.target.value
        });
    }

    setLocation = async (markerDragEvent) => {
        await this.setState({
            ...this.state,
            latitude: markerDragEvent.latLng.lat(),
            longitude: markerDragEvent.latLng.lng()
        });

        this.centerMap();
    }

    onChangeEmpreendimento = async (e) => {
        this.setState({
            ...this.state,
            empreendimento: e,
            building_id: e.value
        });

        let buildingId = e.value;

        if (buildingId !== '') {

            await this.setLoading(true);

            try {
                let response = await axios.get(route('building.show', buildingId));

                if (response.status === 200) {

                    const latitude = parseFloat(response.data.building.latitude);
                    const longitude = parseFloat(response.data.building.longitude);

                    await this.setState({
                        ...this.state,
                        bairro: (response.data.building.neighborhood) ? response.data.building.neighborhood : null,
                        cidade_empreendimento: (response.data.building?.city.city) ? response.data.building?.city.city : null,
                        estado_empreendimento: (response.data.building?.city.state) ? response.data.building?.city.state : null,
                        endereco: (response.data.building.address) ? response.data.building.address : null,
                        numero: (response.data.building.number) ? response.data.building.number : null,
                        complemento: (response.data.building.complement) ? response.data.building.complement : null,
                        cep: response.data.building.zip_code ?? null,
                        latitude: !isNaN(latitude) ? latitude : '',
                        longitude: !isNaN(longitude) ? longitude : '',
                        tipologias: response.data.tipologias

                    });

                    if (isNaN(latitude) || isNaN(longitude)) {
                        await this.getCoordinatesFromAddress();
                    } else {
                        this.centerMap();
                    }
                }
            } finally {
                await this.setLoading(false);
            }
        }
    }


    render() {
        return (<>
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                style={{ width: "50%", zIndex: 9999999, fontWieght: 'bold' }}
            />

            {this.state.loading && <Loader />}

            <form method="post" className="form-chamado">
                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                            <label htmlFor="assunto">Assunto</label>
                            <Select
                                inputId="assunto"
                                placeholder="Selecione o assunto"
                                value={this.state.assunto ? { value: this.state.assunto, label: this.state.assunto } : null}
                                options={[...this.state.assuntos].sort(sortAssuntoOutrosLast).map(a => ({ value: a, label: a }))}
                                onChange={(opt) => this.onChangeAssunto({ target: { value: opt ? opt.value : '' } })}
                                styles={selectStyles}
                            />
                            {this.state.errors['assunto'] &&
                                <div className="invalid-feedback" style={{ display: "block" }}>
                                    {this.state.errors['assunto'][0]}
                                </div>}
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <label htmlFor="observacao">Observação</label>
                            <Select
                                inputId="observacao"
                                placeholder="Selecione a observação"
                                isDisabled={!this.state.assunto || !this.state.observacoes[this.state.assunto]}
                                value={this.state.observacao ? { value: this.state.observacao, label: this.state.observacao } : null}
                                options={(this.state.assunto && this.state.observacoes[this.state.assunto])
                                    ? [...this.state.observacoes[this.state.assunto]].sort((a, b) => a.localeCompare(b, 'pt-BR')).map(o => ({ value: o, label: o }))
                                    : []}
                                onChange={(opt) => this.onChangeObservacao({ target: { value: opt ? opt.value : '' } })}
                                styles={selectStyles}
                            />
                            {this.state.errors['observacao'] &&
                                <div className="invalid-feedback" style={{ display: "block" }}>
                                    {this.state.errors['observacao'][0]}
                                </div>}
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                            <label htmlFor="">Cidade</label>
                            <AsyncSelect
                                cacheOptions
                                placeholder="Selecione a cidade..."
                                value={this.state.cidade}
                                loadOptions={this.searchCidade}
                                onChange={async (e) => {
                                    await this.setState({
                                        ...this.state,
                                        cidade: e
                                    });
                                }}
                                styles={selectStyles}
                            />
                            {this.state.errors['cidade'] &&
                                <div className="invalid-feedback" style={{ display: "block" }}>
                                    {this.state.errors['cidade']}
                                </div>}
                        </div>
                    </div>
                    <div className="col-md-6">
                        {this.state.assunto === 'Inclusão de empreendimento' ? (
                            <div className="form-group">
                                <label htmlFor="nome">Nome do Empreendimento</label>
                                <input type="text"
                                    className={`form-control ` + (this.state.errors.nome ? 'is-invalid' : '')}
                                    name="nome"
                                    onChange={this.onChangeNome}
                                    id="nome" placeholder="Nome do Empreendimento"
                                    value={this.state.nome}
                                    style={{ borderRadius: 0, height: '44px', padding: '9px 12px', boxSizing: 'border-box', ...FIELD_VALUE_FONT }} />
                                {this.state.errors['nome'] &&
                                    <div className="invalid-feedback" style={{ display: "block" }}>
                                        {this.state.errors['nome']}
                                    </div>}
                            </div>
                        ) : (
                            <div className="form-group">
                                <label htmlFor="">Empreendimento</label>
                                <AsyncSelect
                                    cacheOptions
                                    placeholder="Selecione o empreendimento..."
                                    value={this.state.empreendimento}
                                    defaultOptions
                                    loadOptions={this.searchEmpreendimentos}
                                    onChange={this.onChangeEmpreendimento}
                                    styles={selectStyles}
                                />
                                {this.state.errors['empreendimento'] &&
                                    <div className="invalid-feedback" style={{ display: "block" }}>
                                        {this.state.errors['empreendimento']}
                                    </div>}
                            </div>
                        )}
                    </div>
                </div>

                {((this.state.observacao === 'Localização Incorreta' && this.state.building_id !== '') || this.state.assunto === 'Inclusão de empreendimento') &&
                    <EnderecoEnprendimentoPartialForm
                        onChangeEndereco={this.onChangeEndereco}
                        onChangeBairro={this.onChangeBairro}
                        onChangeCep={this.onChangeCep}
                        onChangeCidadeEmpreendimento={this.onChangeCidadeEmpreendimento}
                        onChangeEstadoEmpreendimento={this.onChangeEstadoEmpreendimento}
                        onChangeNumero={this.onChangeNumero}
                        onChangeLatitude={this.onChangeLatitude}
                        onChangeLongitude={this.onChangeLongitude}
                        setLocation={this.setLocation}
                        getCoordinatesFromAddress={this.getCoordinatesFromAddress}
                        state={this.state}
                    />
                }

                {(this.state.observacao === 'Estoque incorreto' || this.state.observacao === 'Valor incorreto') &&
                    <EstoqueValoresForm
                        state={this.state}
                        observacao={this.state.observacao}
                        updateTipologias={this.updateTipologias}
                    />
                }

                {(this.state.observacao === 'Tipologia' || this.state.observacao === 'Ficha técnica') &&
                    this.state.tipologias && this.state.tipologias.length > 0 && (
                    <EstoqueValoresTable
                        tipologias={this.state.tipologias}
                        observacao={this.state.observacao}
                    />
                )}

                <div className="form-group">
                    <label htmlFor="mensagem">Mensagem</label>
                    <textarea className={`form-control ` + (this.state.errors.mensagem ? 'is-invalid' : '')}
                        onChange={this.onChangeMensagem}
                        value={this.state.mensagem}
                        name="mensagem"
                        placeholder="Escreva aqui o detalhamento da sua solicitação.."
                        style={{ height: '150px', borderRadius: 0, resize: 'none', ...FIELD_VALUE_FONT }}
                        id="mensagem"></textarea>
                    {this.state.errors['mensagem'] &&
                        <div className="invalid-feedback" style={{ display: "block" }}>
                            {this.state.errors['mensagem'][0]}
                        </div>}
                </div>

                <div className="chamados-button-group">
                    <label htmlFor="anexos" className="btn btn-anexar" style={{ ...BTN_CHAMADO, backgroundColor: '#B2B2B2', color: '#FFFFFF' }}>
                        Anexar
                    </label>
                    <input type="file" name="anexos[]" onChange={this.onChangefile} id="anexos"
                        multiple="multiple" style={{ display: 'none' }} />
                    <button type="button" className="btn btn-enviar" onClick={this.submitForm} style={{ ...BTN_CHAMADO, backgroundColor: '#4D5A31', color: '#FFFFFF' }}>
                        Enviar
                    </button>
                </div>
                {this.state.errors['anexos'] &&
                    <div className="invalid-feedback" style={{ display: "block", marginTop: '10px' }}>
                        {this.state.errors['anexos'][0]}
                    </div>}
            </form>
        </>);
    }
}

if (document.getElementById('js-form-chamado')) {
    ReactDOM.render(<FormChamado />, document.getElementById('js-form-chamado'));
}
